import { FC } from "react";
import PaginationComponent from "../../pagination/pagination.component";

type ListingPaginationProps = {
  page: number;
  pageSize: number;
  totalResults: number | null;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
  pageSizeOptions?: number[];
  resetTotalResultsKey?: string;
  paginationCountHide?: boolean;
};

const ListingPaginationComponent: FC<ListingPaginationProps> = (props) => {
  return (
    <div className="listing_pagination">
      <PaginationComponent
        onPageChange={props.onPageChange}
        onPageSizeChange={props.onPageSizeChange}
        page={props.page}
        pageSize={props.pageSize}
        totalResults={props.totalResults}
        pageSizeOptions={props.pageSizeOptions}
        resetTotalResultsKey={props.resetTotalResultsKey}
        paginationCountHide={props.paginationCountHide}
      />
    </div>
  );
};

export default ListingPaginationComponent;
